import React from 'react';
import { FileText } from 'lucide-react';
import SystemLogRealDataTable from '@/components/tables/SystemLogRealDataTable';
import { RosterMember } from '@/types';

interface SystemLogPageProps {
  currentUser: RosterMember | null;
}

const SystemLogPage: React.FC<SystemLogPageProps> = ({ currentUser }) => {

  return (
    <div className="bg-kala-800 text-white p-6 rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold mb-6 border-b border-kala-700 pb-3 flex items-center gap-3">
        <FileText className="w-6 h-6" />
        System Event Logs
      </h1>
      {/* Replacing the old simple log list with the new, feature-rich data table */}
      <SystemLogRealDataTable currentUser={currentUser} />
    </div>
  );
};

export default SystemLogPage;
